import { all, takeEvery, takeLatest } from 'redux-saga/effects';
import {
    CHANGE_PLAYER_SELECTION_MODAL_VISIBILITY,
    ADD_PLAYER,
    REMOVE_PLAYER,
    UPDATE_FILTER_ITEM,
    FETCH_SEARCH_RESULTS
} from '../actions';
import { changePlayerSelectionModalVisibility } from './change-modal-visibility';
import { updateFilterItem } from './update-filter-item';
import { fetchSearchResults } from './fetch-search-results';
import { addPlayer, removePlayer } from './add-remove-player';

/**
 *
 */
export function* playerComparisonRootSaga() {
    yield all([
        takeEvery(
            CHANGE_PLAYER_SELECTION_MODAL_VISIBILITY.REQUEST,
            changePlayerSelectionModalVisibility
        ),
        takeLatest(ADD_PLAYER.REQUEST, addPlayer),
        takeEvery(REMOVE_PLAYER.REQUEST, removePlayer),
        takeEvery(UPDATE_FILTER_ITEM.REQUEST, updateFilterItem),
        takeEvery(FETCH_SEARCH_RESULTS.REQUEST, fetchSearchResults)
    ]);
}
